/**
 * API 客户端初始化 Hook
 *
 * 在 App 层调用，配置 baseURL、token 获取、401 处理
 */
import { useEffect } from 'react'
import { createApiClient } from '@cn-kis/api-client'

let initialized = false

export function useApiInit() {
  useEffect(() => {
    if (initialized) return
    initialized = true

    createApiClient({
      baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
      timeout: 30000,
      getToken: () => localStorage.getItem('auth_token'),
      /**
       * 401 时 api-client 已 clearAuthStorage 并派发 cnkis-auth-token-cleared（与飞书 token 态同步）。
       * 勿再跳转 #/login→工作台：旧逻辑会在「storage 已空但 React 仍认为已登录」时形成 401 风暴与飞书授权循环。
       */
      onUnauthorized: () => {},
      /**
       * 本地 Vite：偶发 401（网关/时序/JWT 临界）会清空 token → 立刻回到飞书授权死循环。
       * DEV 下保留 token，由页面提示错误；需重新登录时用户可点退出或清站点数据。生产仍清 storage。
       */
      skipClearAuthStorageOnAuthError: import.meta.env.DEV,
    })
  }, [])
}
